@if (links(); as links) {
  <span>
    @for (link of links; track link.label; let isLast = $last) {
      <span>
        @if (link.routerLink) {
          <a [routerLink]="link.routerLink">
            {{ link.label }}
          </a>
        } @else {
          {{ link.label }}
        }
        @if (link.subLabel) {
          <!-- subLabel is trusted HTML; callers must escapeHtml() user data. -->
          <br /><span class="text-muted" [innerHtml]="link.subLabel"></span>
        }
        @if (link.tag) {
          <span class="badge badge-secondary">{{ link.tag }}</span>
        }
        @if (!isLast) {
          <br />
        }
      </span>
    }
  </span>
}
